import { Reducer } from "redux";

import { UrgencyStatusActionDispatchTypes } from "../constants/Patient";
import { UrgencyStatusMasterResponse } from "../models/Api/Patient";
import { UrgencyStatusDispatchTypes } from "../models/DispatchTypes/Patient";
import { setLocalStorageData } from "../utils";

export const initialState: UrgencyStatusMasterResponse = {
  loading: false,
  response: [],
};

const UrgencyStatusReducer: Reducer<
  UrgencyStatusMasterResponse,
  UrgencyStatusDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS: {
      // AB#33582: only persist/replace with a non-empty list so a transient empty
      // response never blanks the dropdown or poisons the localStorage cache.
      const hasData =
        Array.isArray(action.response) && action.response.length > 0;
      if (!hasData) {
        return {
          ...state,
          loading: false,
        };
      }
      setLocalStorageData(
        UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_ERROR: {
      // AB#33582: keep the last known-good list on error so a failed background
      // master-sync refresh does not clear an already-populated dropdown.
      return {
        ...state,
        loading: false,
      };
    }
  }
  return state;
};

export default UrgencyStatusReducer;
